import { EBenefitStatus, IAccountsReceivable, IBenefit, ICESNumber, IDepartment, IFeesAndPremiums, IFlexibleFieldSet, IGroupConfigurationData, IGroupNumber, INonStandard, IPlan, IStopLoss } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer, ITransformContext } from "./IJsonTransformer";

// TODO this only handles refs, needs to removing categories
// TODO DONT BUS THIS TRANSFORMER WITH ANY OTHER TRANSFORMER
// ** FIRST WE NEED TO REMOVE ALL References for deactivated
// ** SECOND WE NEED TO REMOVE deactivated categories

export class RemoveDeactivatedDataTransformer extends BaseJsonTransformer {
    readonly deactivatedIds = new Map<string, any>();

    async before(json: IGroupConfigurationData): Promise<void> {
        this.deactivatedIds.clear();

        // TODO test?
        await this.clean(json.attributeSets);
        await this.clean(json.nonStandards);

        await this.clean(json.plans);
        await this.clean(json.benefits, 'IBenefit');
        await this.clean(json.stopLoss);
        await this.clean(json.claimsARs);
        await this.clean(json.feesAndPremiums);

        if (json?.groupStructure?.groupNumbers && json.groupStructure.groupNumbers.length > 0)
            await this.clean(json.groupStructure.groupNumbers, 'IGroupNumber');

        if (json?.groupStructure?.cesNumbers && json.groupStructure.cesNumbers.length > 0)
            await this.clean(json.groupStructure.cesNumbers);

        json.notifications = [];
        json.comments = [];
    }

    async clean(list: IPlan[] |
        IBenefit[] |
        IStopLoss[] |
        IAccountsReceivable[] |
        IFeesAndPremiums[] |
        INonStandard[] |
        IFlexibleFieldSet[] |
        IGroupNumber[] |
        ICESNumber[],
        context?:
            'IPlan' |
            'IBenefit' |
            'IStopLoss' |
            'IAccountsReceivable' |
            'IFeesAndPremiums' |
            'INonStandard' |
            'IFlexibleFieldSet' |
            'IGroupNumber' |
            'ICESNumber'
    ) {
        const removed = [] as string[];

        for (let i = list.length - 1; i >= 0; i--) {
            let item = list[i];
            let spliced = false;

            if (!spliced && item.deactivated) {
                list.splice(i, 1);
                this.deactivatedIds.set(item.id, item);
                spliced = true;
            }

            if (context === 'IGroupNumber') {
                let groupNumberItem = item as IGroupNumber
                if (!spliced && groupNumberItem.status?.value === EBenefitStatus.Cancelled) {
                    list.splice(i, 1);
                    this.deactivatedIds.set(item.id, item);
                }
            }

            if (context === 'IBenefit') {
                let benefitItem = item as IBenefit
                if (!spliced && benefitItem.status?.value === EBenefitStatus.Cancelled) {
                    list.splice(i, 1);
                    this.deactivatedIds.set(item.id, item);
                }
            }

            const nonStandards = (item as IBenefit).nonStandards;
            if (nonStandards && nonStandards.length > 0)
                this.clean(nonStandards);

            const attributeSets = (item as IBenefit | IFeesAndPremiums).attributeSets;
            if (attributeSets && attributeSets.length > 0)
                this.clean(attributeSets);
        }
    }

    async transformPlan(plan: IPlan): Promise<boolean | void> {
        if (plan.feesAndPremiumsRef && plan.feesAndPremiumsRef.id)
            if (this.deactivatedIds.has(plan.feesAndPremiumsRef.id))
                plan.feesAndPremiumsRef = null;

        for (let i = plan.benefitRefs.length - 1; i >= 0; i--) {
            let ref = plan.benefitRefs[i];
            if (this.deactivatedIds.has(ref.id)) {
                plan.benefitRefs.splice(i, 1);
            }
        }
    }

    async transformDepartment(department: IDepartment): Promise<boolean | void> {
        if (department.cesNumberRef && department.cesNumberRef.id)
            if (this.deactivatedIds.has(department.cesNumberRef.id))
                department.cesNumberRef = null;
    }

    async transformFeesAndPremium(feesAndPremium: IFeesAndPremiums): Promise<boolean | void> {
        if (feesAndPremium.stopLossRef && feesAndPremium.stopLossRef.id)
            if (this.deactivatedIds.has(feesAndPremium.stopLossRef.id))
                feesAndPremium.stopLossRef = null;
    }

    async transformGroupNumber(groupNumber: IGroupNumber): Promise<boolean | void> {
        if (groupNumber.accountsReceivableRef && groupNumber.accountsReceivableRef.id)
            if (this.deactivatedIds.has(groupNumber.accountsReceivableRef.id))
                delete groupNumber.accountsReceivableRef;

        if (groupNumber.cesNumberRef && groupNumber.cesNumberRef.id)
            if (this.deactivatedIds.has(groupNumber.cesNumberRef.id))
                groupNumber.cesNumberRef = null;

        if (groupNumber.planRef && groupNumber.planRef.id)
            if (this.deactivatedIds.has(groupNumber.planRef.id))
                delete groupNumber.planRef;

        if (groupNumber.stopLossRef && groupNumber.stopLossRef.id)
            if (this.deactivatedIds.has(groupNumber.stopLossRef.id))
                delete groupNumber.stopLossRef;
    }
}